import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MessagePanel from '../../common/components/MessagePanel/MessagePanel';
import { Routes } from '../../config/routes';
import { ValidationContext } from '../../providers/ValidationContext';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';

function ValidationInReviewScreen(): JSX.Element {
  const { validationStatus, getRouteForCurrentStatus } = useContext(ValidationContext);
  const navigate = useNavigate();

  useEffect(() => {
    getRouteForCurrentStatus().then((route) => {
      // do not navigate to the current route
      if (!route || route === Routes.VALIDATION_IN_REVIEW) {
        return;
      }

      navigate(route);
    });
  }, [getRouteForCurrentStatus, navigate, validationStatus]);

  return (
    <MessagePanel
      title="screens.documentPass.inReview.title"
      description="screens.documentPass.inReview.description"
      dataTestId="IN_REVIEW_SCREEN"
      showUserInfo
      showSupportLink
    />
  );
}
export default withRouteAnalytics(ValidationInReviewScreen, Screens.DOCUMENT_IN_REVIEW);
